import React from "react";
import { FlowHeaderProps } from "./types";
import CustomTypography from "../typography";
import "./styles.scss";
import GridMainLayout from "../grid";
import { Grid } from "@mui/material";

const classNameBase = "scd-flow-header";

export default function FlowHeader({
  title,
  image,
  subTitle,
}: FlowHeaderProps): React.JSX.Element {
  const subTitleNode = subTitle ? (
    <CustomTypography variant="h6" className={`${classNameBase}-sub-title`}>
      {subTitle}
    </CustomTypography>
  ) : undefined;

  return (
    <section className={classNameBase}>
      <GridMainLayout>
        <Grid className={`${classNameBase}-wrapper`} size={{ xs: 12 }}>
          {image}
          <div className={`${classNameBase}-content`}>
            <CustomTypography
              variant="h4"
              className={`${classNameBase}-title`}
              component="h1"
            >
              {title}
            </CustomTypography>
            {subTitleNode}
          </div>
        </Grid>
      </GridMainLayout>
    </section>
  );
}
